import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/shrikhand-gujarati-normal-c941bf01.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22shrikhand%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0951-0952,%20U+0964-0965,%20U+0A80-0AFF,%20U+200C-200D,%20U+20B9,%20U+25CC,%20U+A830-A839%22}]}],%22variableName%22:%22shrikhandGujarati%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'shrikhandGujarati'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
